webpackJsonp([216277985284727],{

/***/ 139:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Phanor Coll - Fullstack Developer","author":"Phanor Coll","description":"gopher in action"}}},"layoutContext":{}}

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ebookLayout = __webpack_require__(310);
	
	var _ebookLayout2 = _interopRequireDefault(_ebookLayout);
	
	var _layoutEbookLayout = __webpack_require__(139);
	
	var _layoutEbookLayout2 = _interopRequireDefault(_layoutEbookLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_ebookLayout2.default, _extends({}, props, _layoutEbookLayout2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _linuxLogo = __webpack_require__(204);
	
	var _linuxLogo2 = _interopRequireDefault(_linuxLogo);
	
	var _coffeeCup = __webpack_require__(70);
	
	var _coffeeCup2 = _interopRequireDefault(_coffeeCup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer(props) {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Footer.prototype.render = function render() {
	    var data = this.props.info;
	
	    return _react2.default.createElement(
	      'footer',
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'social-networks' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'http://phanorcoll.deviantart.com/',
	                className: 'a-animation'
	              },
	              'deviantart'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://twitter.com/phanor/', className: 'a-animation' },
	              'twitter'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/phanorcoll', className: 'a-animation' },
	              'github'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              {
	                href: 'https://www.linkedin.com/in/phanorcoll/',
	                className: 'a-animation'
	              },
	              'linkedin'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'copyright' },
	          _react2.default.createElement(
	            'div',
	            null,
	            '\xA9 2018 \xA0',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://twitter.com/phanor', className: 'a-animation' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                data.site.siteMetadata.author
	              )
	            ),
	            '. All Rights Reserved.'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Made with lots of',
	            _react2.default.createElement('img', { src: _coffeeCup2.default, alt: data.site.siteMetadata.author }),
	            ' on',
	            _react2.default.createElement('img', { src: _linuxLogo2.default, alt: data.site.siteMetadata.author }),
	            ' using \xA0',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.gatsbyjs.org/', className: 'a-animation' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Gatsbyjs'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/linux-logo.674df11b.svg";

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Footer = __webpack_require__(105);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ebookLayout = function (_Component) {
	  _inherits(ebookLayout, _Component);
	
	  function ebookLayout(props) {
	    _classCallCheck(this, ebookLayout);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  ebookLayout.prototype.render = function render() {
	    var data = this.props.data;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'ebook-wrapper' },
	        this.props.children()
	      ),
	      _react2.default.createElement(_Footer2.default, { info: data })
	    );
	  };
	
	  return ebookLayout;
	}(_react.Component);
	
	exports.default = ebookLayout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-ebook-layout-jsx-747de2714d4b5fecc9b8.js